function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
import { action, computed, makeObservable, observable } from "mobx";
import * as utils from '../widget/Utils';
var UiStore = /*#__PURE__*/function () {
  function UiStore() {
    _classCallCheck(this, UiStore);
    _defineProperty(this, "successMessages", []);
    _defineProperty(this, "infoMessages", []);
    _defineProperty(this, "warningMessages", []);
    _defineProperty(this, "dangerMessages", []);
    _defineProperty(this, "isLoading", false);
    _defineProperty(this, "numberCallback", 0);
    // @ts-ignore
    makeObservable(this, {
      successMessages: observable,
      infoMessages: observable,
      warningMessages: observable,
      dangerMessages: observable,
      isLoading: observable,
      numberCallback: observable,
      messagesCount: computed,
      addSuccessMessage: action,
      addInfoMessage: action,
      addWarningMessage: action,
      addDangerMessage: action,
      clearMessages: action
    });
  }
  return _createClass(UiStore, [{
    key: "messagesCount",
    get: function get() {
      return this.successMessages.length + this.infoMessages.length + this.warningMessages.length + this.dangerMessages.length;
    }
  }, {
    key: "addSuccessMessage",
    value: function addSuccessMessage(message) {
      utils.scrollToTop();
      this.successMessages.push(message);
    }
  }, {
    key: "addInfoMessage",
    value: function addInfoMessage(message) {
      this.infoMessages.push(message);
    }
  }, {
    key: "addWarningMessage",
    value: function addWarningMessage(message) {
      this.warningMessages.push(message);
    }
  }, {
    key: "addDangerMessage",
    value: function addDangerMessage(message) {
      utils.scrollToTop();
      this.dangerMessages.push(message);
    }
  }, {
    key: "clearMessages",
    value: function clearMessages() {
      this.successMessages = this.successMessages.filter(function (elem) {
        return elem.persist;
      });
      this.infoMessages = this.infoMessages.filter(function (elem) {
        return elem.persist;
      });
      this.warningMessages = this.warningMessages.filter(function (elem) {
        return elem.persist;
      });
      this.dangerMessages = this.dangerMessages.filter(function (elem) {
        return elem.persist;
      });
    }
  }, {
    key: "handleSpinner",
    value: function handleSpinner(numberCb) {
      this.isLoading = numberCb == 0 ? false : true;
    }
  }]);
}();
export default UiStore;